import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsTemperatureMetadataServices } from "../../../../APIServices/EIWRS/ShipmentManagement/eiwrsTemperatureMetadataServices";

const UpdateStudyTemperatureMetadata = ({
  temperatureData,
  getEIWRSTemperatureMetadataData,
  Show,
  Hide,
  Title,
  setTemperatureId,
}) => {
  const { studyId } = useParams()
  const [temperature, setTemperature] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateEIWRSTemperatureMetadataData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Temperature!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = temperatureData?._id;
        userData.studyId = studyId;
        userData.temperature = temperature;
        let data = await eiwrsTemperatureMetadataServices.updateEIWRSTemperatureMetadataData(
          userData
        );
        if (data?.statusCode === 200) {
          getEIWRSTemperatureMetadataData();
          Hide();
          setTemperatureId("");
          setTemperature("");
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setTemperature(temperatureData?.temperature);
  }, [temperatureData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Temperature{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setTemperature(e.target.value)}
              value={temperature}
              className="br3"
              placeholder="Enter Temperature"
              type="text"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!temperature || buttonLoader}
            className="updateProfile"
            onClick={(e) => updateEIWRSTemperatureMetadataData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm"/> Updating...
              </div>
            ) : (
              "Update Temperature"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateStudyTemperatureMetadata;
